import './App.css';
import Header from './component/Header';
import Landing from './component/Landing';
import Presentation from './component/Presentation';
import Magnetisme from './component/Magnetisme';
import Contact from './component/Contact';
import Tarif from './component/Tarif';
import Footer from './component/Footer';
import Error from './component/Error';
import { Routes, Route } from 'react-router-dom';
 


function App() {
  return (
    <>      
      
        <Routes>
          <Route path="/" element={
            <>
              <Header/>
              <Landing/>              
              <Presentation/>
              <Magnetisme/>
              <Contact/>
              <Tarif/>
            </>
          } />
          <Route path="/accueil" element={
            <>              
              <Header/>
              <Landing/>              
              <Presentation/>
              <Magnetisme/>
              <Contact/>
              <Tarif/>
            </>            
          } /> 
          <Route path="*" element={<Error/>} />       
</Routes>
      <Footer/>
    </>
  );
}

export default App;
